import {
  buildAdditionalContactCard,
  type ContactCardOverrides,
} from './additionalContactCard';

export const attorneyContactCard = buildAdditionalContactCard({
  contactType: 'attorney',
  contactLabel: 'Attorney',
  overrides: {
    fields: {
      role: {
        label: 'Role',
        placeholderText: 'Attorney, Assistant, etc',
      },
    },
  } satisfies ContactCardOverrides,
});
